<template>
  <v-dialog
    v-model="dialog"
    width="640px">
    <div class="dialog-container">
      <div class="dialog-header">
        <span class="title">Claim Ticket</span>
        <span>#{{ claimEditData.ticket_id }}</span>
      </div>
      <div class="dialog-content">
        <div
          v-for="(item, index) in claimEditData.log"
          :key="index"
          :class="{ 'mask-container': isEdit && editIndex !== index }"
          class="content">
          <div class="abs-top-right">
            <div v-if="editIndex !== index">
              <span
                class="edit"
                @click="handlerEditLog(index)">Edit</span>
              <span
                class="delete"
                @click="handlerDeleteLog(index)">Delete</span>
            </div>
            <div v-if="editIndex === index">
              <v-button
                type="primary"
                plain
                @click="cancelEdit">Cancel Edit
              </v-button>
              <v-button
                type="primary"
                @click="editDone">Done
              </v-button>
            </div>
          </div>
          <section
            v-if="editIndex !== index">
            <div>
              <span class="time">{{ item.created_at }}</span>
              <span>{{ item.assignee }}</span>
            </div>
            <p>{{ item.content }}</p>
            <file-container
              v-for="(file, fIndex) in item.other_file"
              :key="fIndex"
              :fileData="file"/>
          </section>
          <section v-if="editIndex === index">
            <div class="form-item mg-t-15">
              <span>Content</span>
              <v-input
                v-model="editLog.content"
                type="textarea"
                :rows="4"/>
            </div>
            <file-container
              v-for="(file, fIndex) in editLog.other_file"
              :key="fIndex"
              :fileData="file"
              :otherData="{
                type: 'edit',
                index
              }"
              :edit="true"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"/>
            <div class="form-item">
              <span>Upload File</span>
              <v-upload
                :otherData="{
                  type: 'edit'
                }"
                @uploadSuccess="handlerUploadSuccess"/>
            </div>
          </section>
        </div>
        <div
          v-if="!isEdit"
          class="content">
          <section v-if="editNew">
            <span class="new-entry">New Entry</span>
            <div class="abs-top-right">
              <v-button
                type="primary"
                plain
                @click="cancelNew">Cancel New Entry
              </v-button>
              <v-button
                type="primary"
                @click="addDone">Done
              </v-button>
            </div>
            <div class="form-item">
              <span>Content</span>
              <v-input
                v-model="addLog.content"
                type="textarea"
                :rows="4"/>
            </div>
            <file-container
              v-for="(item, index) in addLog.other_file"
              :key="index"
              :edit="true"
              :fileData="item"
              :otherData="{
                type: 'add',
                index
              }"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"/>
            <div class="form-item">
              <span>Upload File</span>
              <v-upload
                :otherData="{
                  type: 'add'
                }"
                @uploadSuccess="handlerUploadSuccess"/>
            </div>
          </section>
          <v-button
            v-else
            type="primary"
            @click="handlerAddEntry">Add New Entry
          </v-button>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="flex-sb">
          <div>
            <v-button @click="handlerExit">Exit</v-button>
          </div>
          <div>
            <v-button
              type="primary"
              :disabled="disabledConfirm"
              @click="handlerExit">Confirm
            </v-button>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import FileContainer from '@/views/components/file-container'
import {addClaimLog, editClaimLog, deleteClaimLog} from '@/api/claim'

export default {
  name: 'ClaimDetailDialog',
  components: {
    FileContainer
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog: false,
      claimEditData: {},
      editIndex: -1,
      editNew: false,
      editLog: {},
      addLog: {
        content: '',
        other_file: []
      }
    }
  },
  computed: {
    isEdit() {
      return this.editIndex !== -1
    },
    disabledConfirm() {
      if (this.isEdit || this.editNew) {
        return true
      }
      return false
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        this.claimEditData = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerEditLog(index) {
      this.editIndex = index
      this.editLog = JSON.parse(JSON.stringify(this.claimEditData.log[index]))
    },
    handlerDeleteLog(index) {
      const {id} = this.claimEditData.log[index]
      this.network().deleteClaimLog(id, index)
    },
    cancelEdit() {
      this.editIndex = -1
    },
    editDone() {
      this.network().editClaimLog()
    },
    handlerAddEntry() {
      this.editNew = true
    },
    cancelNew() {
      this.editNew = false
    },
    addDone() {
      this.network().addClaimLog()
    },
    handlerExit() {
      // todo 傳值出去
      this.$emit('save', this.claimEditData)
      // this.claimsList[this.claimIndex].record[this.recordIndex] = this.claimEditData
      this.dialog = false
    },
    handlerDeleteFile(otherData) {
      const {index, type} = otherData
      if (type === 'add') {
        this.addLog.other_file.splice(index, 1)
      } else {
        this.editLog.other_file.splice(index, 1)
      }
    },
    handlerUploadSuccess({data, result, otherData}) {
      const {type, index = ''} = otherData
      if (!this.addLog.other_file) {
        this.addLog.other_file = []
      }
      if (!this.editLog.other_file) {
        this.editLog.other_file = []
      }
      if (type === 'add') {
        if (index !== '') {
          // this.addLog.other_file[index] = data
          this.$set(this.addLog.other_file, index, data)
        } else {
          this.addLog.other_file.push(data)
        }
      } else {
        if (index !== '') {
          this.$set(this.editLog.other_file, index, data)
          // this.editLog.other_file[index] = data
        } else {
          this.editLog.other_file.push(data)
        }
      }
    },
    network() {
      return {
        addClaimLog: async () => {
          const {data} = await addClaimLog({
            ...this.addLog,
            claim_id: this.claimEditData.id
          })
          if (!this.claimEditData.log) {
            this.claimEditData.log = []
          }
          this.claimEditData.log.push(data)
          this.editNew = false
          // 清空数据？
          this.addLog = {
            content: '',
            other_file: []
          }
        },
        deleteClaimLog: async (id, index) => {
          const {data} = await deleteClaimLog({
            claim_log_id: id
          })
          this.claimEditData.log.splice(index, 1)
        },
        editClaimLog: async () => {
          const {data} = await editClaimLog({
            ...this.editLog,
            claim_log_id: this.editLog.id
          })
          this.claimEditData.log[this.editIndex] = Object.assign(
            this.claimEditData.log[this.editIndex],
            this.editLog
          )
          this.editIndex = -1
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  padding: 15px;
  white-space:pre-wrap;

  .dialog-header {
    margin: 0 -15px;
    padding: 0 15px;
    border-bottom: 1px solid #dddfe7;

    .title {
      padding-right: 15px;
    }
  }

  .dialog-content {
    margin: 0 -15px;

    .content {
      position: relative;
      padding: 15px;
      border-bottom: 1px solid #dddfe7;
      font-size: 14px;
      color: #91939A;

      .new-entry {
        display: inline-block;
        padding-bottom: 10px;
        font-size: 16px;
        color: #616266;
      }

      .abs-top-right {
        z-index: 3;
        top: 15px;
        right: 15px;

        .edit {
          display: inline-block;
          margin-right: 15px;
          color: #409eff;
          cursor: pointer;
        }

        .delete {
          color: #f56c6d;
          cursor: pointer;
        }
      }

      .time {
        display: inline-block;
        padding-right: 10px;
        font-weight: 500;
        color: #616266;
      }

      p {
        padding: 10px 0;
        color: #616266;
        line-height: 16px;
      }
    }
  }

  .dialog-footer {
    padding-top: 15px;
  }
}
</style>